import { useV2GetAccountQuery } from "@generated";

const useGetAccount = () => {
  const { data, isLoading } = useV2GetAccountQuery({});
  const accountId = data?.data?.attributes?.["account-id"] as
    | number
    | undefined;
  return { accountId, account: data?.data, accountLoading: isLoading };
};

export default useGetAccount;
